/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState, useEffect } from "react";
import { View } from "react-native";

import UserDropDown from "./UserDropDown";
import OptionRadioButton from "./OptionRadioButton";
import UserEmailTextField from "./UserEmailTextField";

import { callApi } from "config/UpduoService";

import { skalePrimaryBlue, skaleRed, skaleWhite } from "config/UpduoColors";
import { Button, Text } from "UpduoLibrary";
import { validateEmail } from "config/Utilities";

export default function ErrorRow({ item, itemIndex }) {
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [selectedUserEmail, setSelectedUserEmail] = useState("Select user");
  const [selectedRadioButtonValue, setSelectedRadioButtonValue] = useState("1");
  const [isSelectUserButtonPressed, setIsSelectUserButtonPressed] =
    useState(false);
  const [userArray, setUserArray] = useState([]);
  const [typedEmail, setTypedEmail] = useState("");
  const [typedEmailValidated, setTypedEmailValidated] = useState(false);
  const [singleUploadResults, setSingleUploadResults] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const _handleChangeTypedEmail = (event) => {
    setTypedEmail(event.target.value);
    setTypedEmailValidated(validateEmail(event.target.value));
  };

  useEffect(() => {
    if (isSelectUserButtonPressed) {
      _handleSelectUser();
    }
  }, [isSelectUserButtonPressed]);

  const _handleSelectUser = () => {
    callApi(
      "getOrgUserList",
      undefined,
      (responseJson) => {
        let newUserArray = responseJson;
        if (newUserArray.length > 1) {
          newUserArray = newUserArray.sort((a, b) => {
            if (a.first_name === null || b.first_name === null) return 0;
            return a.first_name.localeCompare(b.first_name);
          });
        }
        setUserArray(newUserArray);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const _handleChangeUser = (value) => {
    if (value.id === selectedUserId) {
      return;
    }
    setSelectedUserId(value.id);
    setSelectedUserEmail(value.primary_email);
  };

  let userDropDownText = "Select user";
  switch (selectedUserId) {
    case selectedUserId:
      userDropDownText = selectedUserEmail;
      break;
    default:
      break;
  }

  const _handleChange = (event) => {
    setSelectedRadioButtonValue(event.target.value);
  };

  switch (selectedRadioButtonValue) {
    case "1":
      if (!isSelectUserButtonPressed) {
        setIsSelectUserButtonPressed(true);
      }
      break;
    case "2":
      if (isSelectUserButtonPressed) {
        setIsSelectUserButtonPressed(false);
      }
      break;
    case "3":
      if (isSelectUserButtonPressed) {
        setIsSelectUserButtonPressed(false);
      }
      break;
    default:
      break;
  }

  const _handlePostSingleUserMetricNew = (item) => {
    setIsLoading(true);
    let userValue = item.user;
    if (selectedUserEmail && selectedUserEmail !== "Select user") {
      userValue = selectedUserEmail;
    } else if (typedEmailValidated) {
      userValue = typedEmail;
    }
    const body = {
      user: userValue,
      data: item.row_data,
    };
    callApi(
      "postUserMetricNew",
      body,
      (responseJson) => {
        setSingleUploadResults(responseJson);
        setIsLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const resultMessage = (
    <View>
      <Text style={{ color: skaleRed }}>
        {singleUploadResults["Errors"] && singleUploadResults["Errors"][0]
          ? "Error uploading. User not uploaded."
          : null}
      </Text>
      <Text>
        {singleUploadResults["Created"] && singleUploadResults["Created"][0]
          ? singleUploadResults["Created"][0]["detail"]
          : null}
      </Text>
    </View>
  );

  return (
    <View style={{ marginBottom: 10, marginLeft: 15 }} key={itemIndex}>
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
          marginLeft: 30,
        }}
      >
        <OptionRadioButton
          onChangeOption={_handleChange}
          selectedRadioButtonValue={selectedRadioButtonValue}
        />
        <View style={{ flex: 1, flexDirection: "row" }}>
          {selectedRadioButtonValue === "1" ? (
            <UserDropDown
              onChangeUser={_handleChangeUser}
              userDropDownText={userDropDownText}
              userArray={userArray}
            />
          ) : null}
          {selectedRadioButtonValue === "2" ? (
            <UserEmailTextField
              onChange={_handleChangeTypedEmail}
              typedEmailValidated={typedEmailValidated}
            />
          ) : null}
          <View
            style={{
              marginTop: 5,
              maxWidth: 550,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontSize: 16,
              }}
            >
              {item.detail}
            </Text>
            {!isLoading ? resultMessage : null}
          </View>
        </View>
        <View style={{ position: "absolute", right: 40 }}>
          <Button
            onPress={() => {
              if (selectedRadioButtonValue === "1" && selectedUserId !== 0) {
                _handlePostSingleUserMetricNew(item);
                setSubmitButtonPressed(true);
              } else if (
                selectedRadioButtonValue === "2" &&
                typedEmailValidated
              ) {
                _handlePostSingleUserMetricNew(item);
                setSubmitButtonPressed(true);
              } else if (selectedRadioButtonValue === "3") {
                setSubmitButtonPressed(true);
              }
            }}
            disabled={submitButtonPressed}
            // color={skaleBlue}
            width={90}
            text={"Submit"}
            height={28}
            borderWidth={1}
            borderColor={skalePrimaryBlue}
            color={skaleWhite}
            textColor={skalePrimaryBlue}
          />
        </View>
      </View>
    </View>
  );
}
